import * as React from 'react';
import {translate, InjectedTranslateProps, InjectedI18nProps} from 'react-i18next';
import {reportClick, reportSecondaryCtaClick} from '../../utils/bi';
import LinkMore from '../LinkMore';
import ArrowLink from '../ArrowLink';
import Text from '../Text';
import * as s from './FreeSite.scss';
import {learnMore} from '../../utils/ctaLinks';

export interface FreeSiteConfig {
  key: string;
}

export interface FreeSiteProps extends InjectedTranslateProps, InjectedI18nProps, FreeSiteConfig {
}

const reportLearnMoreClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  reportSecondaryCtaClick(e.currentTarget);
};

const readMoreLangs = ['en', 'es', 'it', 'fr', 'ja'];

const FreeSite: React.SFC<FreeSiteProps> = ({t, i18n: {language}}) => {
  return (
    <div
        className={`page-fold ${s.freeSite}`}
        data-hook="free-site-fold"
        data-foldname="free-site"
        data-foldnum="6"
    >
      <div className={s.inner}>
        <h2 className={s.title}>
          <a data-hook="free-site-title" data-foldname="free-site" data-message="learn more" href={learnMore()} onClick={reportLearnMoreClick}>
            <Text i18nKey="freeSite.title"/>
          </a>
        </h2>
        <div className={s.description}>
          <Text parent="p" className={s.subtitle} i18nKey="freeSite.subtitle"/>

          <ol className={s.stepsList}>
            <Text parent="li" i18nKey="freeSite.step1" />
            <Text parent="li" i18nKey="freeSite.step2" />
            <Text parent="li" i18nKey="freeSite.step3" />
            <Text parent="li" i18nKey="freeSite.step4" />
            <Text parent="li" i18nKey="freeSite.step5" />
          </ol>
        </div>
        <div className={s.buttons}>
          <LinkMore
            className={s.getStarted}
            theme="light"
            data-hook="free-site-get-started"
            data-foldname="free-site"
            onClick={reportClick}
          >
            {t('button.getStarted')}
          </LinkMore>
          {readMoreLangs.includes(language) ? <ArrowLink
            data-hook="free-site-learn-more"
            className={s.learnMore}
            theme="light"
            href={learnMore()}
            data-foldname="free-site"
            data-message="learn more"
            onClick={reportLearnMoreClick}
          >
            {t('button.learnMore')}
          </ArrowLink> : null}
        </div>
      </div>
    </div>
  );
};

export default translate()(FreeSite);
